export const ACTION_EVENT: any = {
  RELOAD_DATA: 'ACTION_EVENT_RELOAD_DATA',
  AUTH_UPDATE: 'ACTION_EVENT_AUTH_UPDATE',
};
